import { useReducer } from "react";
import { Box as RBox, Flex, Text } from "@dna/react";
import { PillIcon, MedicationHistoryIcon } from "@communicare/medications/Components/Icons";
import { TwoPanelLayout } from "@communicare/medications/Components/TwoPanelLayout";
import { PharmacyErrors, SelectableMedication, usePharmacyMedicationsLoader} from "./usePharmacyMedications";
import { DetailsPaneState} from '@communicare/medications/Components/DetailsPane';
import { RenderIf } from "../common/render-if/RenderIf";
import { PharmacyMedicationsLoader } from "./PharmacyMedicationsLoader";
import { TabsComponent } from "../common";
import { PharmacyRequests } from "@communicare/medications/PharmacyRequests/PharmacyRequests";
import { PharmacyMedicationsChart } from "../pharmacy-medications/pharmacy-medication-details/PharmacyMedicationsChart";
import { useHistory, useRouteMatch } from "react-router-dom";

enum PharmacyMedicationsComponentActions {
    ToggleFilter,
    ToggleView,
    SelectMedication,
    OpenDoseTimesEditor,
    CloseDoseTimesEditor,
}

type payload = {
    medicationAuthoringSystem: string;
    medicationAuthoringSystemForeignKey: string;
    encounterAuthoringSystem: string;
    encounterAuthoringSystemForeignKey: string;
} | null;
interface UIState {
    filterOpen: boolean;
    dosageTimesEditorState:'Open'|'Close';
    paneState: DetailsPaneState;
    selectedMedication: payload;
}

function togglePaneState(paneState: DetailsPaneState) {
    return paneState === DetailsPaneState.ChildView ?
        DetailsPaneState.ParentView : DetailsPaneState.ChildView;
}
function reducer(state: UIState, action: { type: PharmacyMedicationsComponentActions, payload: payload }): UIState {

    switch (action.type) {
        case PharmacyMedicationsComponentActions.ToggleFilter:
            return {
                ...state,
                filterOpen: !state.filterOpen
            };
        case PharmacyMedicationsComponentActions.ToggleView:
            return {
                ...state,
                paneState: togglePaneState(state.paneState),
                selectedMedication: action.payload
            }
        case PharmacyMedicationsComponentActions.SelectMedication:
            return {
                ...state,
                paneState: DetailsPaneState.ChildView,
                selectedMedication: action.payload ? { ...action.payload } : null
            };
        case PharmacyMedicationsComponentActions.OpenDoseTimesEditor:
            return {
                ...state,
                paneState: DetailsPaneState.ChildView,
                dosageTimesEditorState:"Open"
            };
        case PharmacyMedicationsComponentActions.CloseDoseTimesEditor:
            return {
                ...state,
                paneState: DetailsPaneState.ChildView,
                dosageTimesEditorState:"Close"
            };
    }
}

export interface IPharmacyMedicationsProps {
    residentAuthoringSystem: string;
    residentAuthoringSystemForeignKey: string;
}

export const PharmacyMedicationsDetails = (props: IPharmacyMedicationsProps) => {
    let authoringSystem = props.residentAuthoringSystem;
    let authoringSystemForeignKey = props.residentAuthoringSystemForeignKey;
    let { loading, error, data, getEncounterInfo } = usePharmacyMedicationsLoader(authoringSystem || '', authoringSystemForeignKey || '');
    let [uiState] = useReducer(reducer, {
        selectedMedication: null,
        paneState: DetailsPaneState.ParentView,
        filterOpen: false,
        dosageTimesEditorState:'Close'
    });  

    let { push } = useHistory();
    let { url } = useRouteMatch();
    let chartPath = `${url}`;
  
    let navigateToConfirm = (medicationId?: string) => {
        push(`${chartPath}/confirm/${medicationId}`, {
            hideLoadAnimation: true,
            onCloseRouteToMedications: true
        })
    };

    let encounterInfo = getEncounterInfo();
    return (
        <Flex
            css={{
                flex: 1,
                gap: "0"
            }}
        >
            <PharmacyMedicationsLoader
                error={error && error===PharmacyErrors.MedicationLoadingError}
                inProgress={loading}
                empty={data?.meds.length <= 0}
            >
                <TabsComponent
                    headers={[
                        <div>
                            <PillIcon
                                style={{
                                    verticalAlign: "middle",
                                    minHeight: "1px",
                                    height: "16px",
                                    minWidth: "1px",
                                    width: "16px",
                                }}
                            />{" "}
                            <Text level="small" as="strong">MEDICATION CHART</Text>
                        </div>,
                        <div>
                            <MedicationHistoryIcon
                                style={{
                                    verticalAlign: "middle",
                                    minHeight: "1px",
                                    height: "16px",
                                    minWidth: "1px",
                                    width: "16px",
                                }}
                            />{" "}
                            <Text level="small" as="strong">Change history</Text>
                        </div>
                    ]}
                    content={[
                        <TwoPanelLayout
                            leftPanelOpen={uiState.filterOpen}
                            noPadding
                            contentsLeft
                            mask
                            leftPanel={<h4>Placeholder</h4>}
                            contents={
                              <PharmacyMedicationsChart residentAuthoringSystem={props.residentAuthoringSystem||''} residentAuthoringSystemForeignKey={props.residentAuthoringSystemForeignKey||''} onConfirm={navigateToConfirm}  />
                            }
                        />,
                        <RenderIf if={!!encounterInfo}>

                            <PharmacyRequests patient={{
                                authoringSystem: authoringSystem,
                                authoringSystemForeignKey: authoringSystemForeignKey
                            }} service={{
                                authoringSystem: encounterInfo?.authoringSystem,
                                authoringSystemForeignKey: encounterInfo?.authoringSystemForeignKey
                            }}
                                baseUrl={''}     
                                headlessMode={true}                           
                                routeToMedications={() => { }}
                            />
                        </RenderIf>
                    ]}
                />
            </PharmacyMedicationsLoader>

        </Flex>
    );
};
